import React from 'react';
import { ChevronRight, ShieldCheck, Banknote, Calendar } from 'lucide-react';

const Hero = ({ onCtaClick }) => {
    return (
        <section className="hero">
            <div className="container">
                <div className="hero-content">
                    <div className="badge">
                        <span className="badge-dot"></span>
                        Nova Resolução do Contran (Dez/2025)
                    </div>
                    <h1>
                        A liberdade de dirigir <br />
                        <span className="gradient-text">do seu jeito</span>.
                    </h1>
                    <p className="subtitle">
                        O fim da obrigatoriedade das autoescolas chegou.
                        Economize até 80% na sua CNH e escolha seu instrutor para as 2 horas práticas obrigatórias.
                    </p>

                    <div className="cta-group">
                        <button onClick={() => onCtaClick('student')} className="btn-primary flex-center">
                            Quero minha CNH
                            <ChevronRight size={20} />
                        </button>
                        <button onClick={() => onCtaClick('instructor')} className="btn-secondary">
                            Sou Instrutor
                        </button>
                    </div>

                    <div className="stats-grid">
                        <div className="stat-item glass-panel">
                            <Banknote className="stat-icon" />
                            <div>
                                <strong>-80% Custo</strong>
                                <span>Mais acessível</span>
                            </div>
                        </div>
                        <div className="stat-item glass-panel">
                            <Calendar className="stat-icon" />
                            <div>
                                <strong>Apenas 2h</strong>
                                <span>Prática obrigatória</span>
                            </div>
                        </div>
                        <div className="stat-item glass-panel">
                            <ShieldCheck className="stat-icon" />
                            <div>
                                <strong>100% Legal</strong>
                                <span>Resolução Dez/2025</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        .hero {
          padding: 6rem 0 4rem;
          min-height: 90vh;
          display: flex;
          align-items: center;
          background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.15), transparent 40%),
                      radial-gradient(circle at bottom left, rgba(139, 92, 246, 0.1), transparent 40%);
        }
        .hero-content {
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .badge {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(59, 130, 246, 0.1);
          color: var(--color-primary);
          padding: 0.5rem 1rem;
          border-radius: 2rem;
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 2rem;
          border: 1px solid rgba(59, 130, 246, 0.2);
        }
        .badge-dot {
          width: 8px;
          height: 8px;
          background: var(--color-primary);
          border-radius: 50%;
          box-shadow: 0 0 10px var(--color-primary);
        }
        h1 {
          font-size: 3.5rem;
          line-height: 1.1;
          font-weight: 800;
          margin-bottom: 1.5rem;
          letter-spacing: -0.02em;
        }
        .subtitle {
          font-size: 1.25rem;
          color: var(--color-text-muted);
          margin-bottom: 3rem;
          max-width: 600px;
          line-height: 1.6;
        }
        .cta-group {
          display: flex;
          gap: 1rem;
          margin-bottom: 4rem;
        }
        .flex-center {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .btn-secondary {
          background: transparent;
          border: 1px solid var(--color-border);
          color: var(--color-text-main);
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-weight: 500;
          transition: all 0.2s;
        }
        .btn-secondary:hover {
          background: var(--color-surface);
          border-color: var(--color-text-muted);
        }
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
          width: 100%;
        }
        .stat-item {
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
          text-align: left;
        }
        .stat-icon {
          color: var(--color-accent);
          width: 32px;
          height: 32px;
        }
        .stat-item strong {
          display: block;
          font-size: 1.125rem;
        }
        .stat-item span {
          font-size: 0.875rem;
          color: var(--color-text-muted);
        }
        
        @media (max-width: 768px) {
          h1 {
            font-size: 2.5rem;
          }
          .stats-grid {
            grid-template-columns: 1fr;
          }
          .cta-group {
            flex-direction: column;
            width: 100%;
          }
          .btn-primary, .btn-secondary {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
        </section>
    );
};

export default Hero;
